/** Connexion temps réel à un document (Y.Doc + WebsocketProvider + awareness). */
import * as Y from 'yjs';
import { WebsocketProvider } from 'y-websocket';
import { el, clear } from './ui/dom.js';

const PALETTE = ['#ef795b', '#4a86ff', '#23b26d', '#f5a623', '#a855f7', '#ec4899', '#06b6d4', '#f97316'];

export function colorFromId(id) {
  let h = 0;
  for (let i = 0; i < String(id).length; i++) h = (h * 31 + String(id).charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function displayName(u) {
  return `${u.given_name || ''} ${u.family_name || ''}`.trim() || u.nickname || 'Invité';
}

/** Ouvre la room de collaboration d'un node. */
export function connectDoc(nodeId, user) {
  const doc = new Y.Doc();
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  const provider = new WebsocketProvider(`${proto}//${location.host}/collab`, nodeId, doc, { connect: true });
  const color = colorFromId(user.id);
  provider.awareness.setLocalStateField('user', {
    id: user.id,
    name: displayName(user),
    color,
    picture: user.picture || null,
  });
  return { doc, provider, color };
}

/** Affiche les avatars des collaborateurs présents, mis à jour en direct. */
export function renderPresence(container, provider, selfId) {
  const update = () => {
    clear(container);
    const seen = new Set();
    provider.awareness.getStates().forEach((state) => {
      const u = state.user;
      if (!u || seen.has(u.id)) return;
      seen.add(u.id);
      const av = el('div', { class: 'avatar sm', title: u.name, style: { background: u.color } });
      if (u.picture) av.appendChild(el('img', { src: u.picture, alt: '' }));
      else av.textContent = (u.name[0] || '?').toUpperCase();
      if (u.id === selfId) av.style.outline = '2px solid var(--coral)';
      container.appendChild(av);
    });
  };
  provider.awareness.on('change', update);
  update();
  return () => provider.awareness.off('change', update);
}

export { Y };
